/** Semantic product action → the dealer page that resolves it. An action type not listed here
 * opens the sales contact instead. */
export const ACTION_ROUTES: Readonly<Record<string, string>> = {
  pay_now: '/invoices',
  update_payment_method: '/billing-preferences',
};
